import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';

const benefits = [
  { icon: 'ri-layout-grid-line', title: 'Tam İzolasyon', desc: 'Her VDC bağımsız olarak çalışarak performansı güvence altına alır ve güvenliği artırır.' },
  { icon: 'ri-settings-2-line', title: 'Basitleştirilmiş Yönetim', desc: 'VDC\'lerin kolaylaştırılmış yönetimi ve otomasyonu için basit arayüz.' },
  { icon: 'ri-brush-line', title: 'Gelişmiş Özelleştirme', desc: 'Kullanıcılar belirli operasyonel ihtiyaçlar için VDC\'leri özelleştirebilir.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Ekonomik Verimlilik', desc: 'Kaynak kullanımını optimize eder; çok kiracılılığın avantajları ile birlikte maliyet etkinliği sağlar.' },
];

const useCases = [
  { icon: 'ri-shield-star-line', title: 'Felaket Kurtarma', desc: 'İş sürekliliği için her VDC\'de özelleştirilebilir DR protokolleri.' },
  { icon: 'ri-test-tube-line', title: 'Yama Testi', desc: 'Yazılım güncellemelerinin test edilmesi için güvenli, izole edilmiş ortamlar.' },
  { icon: 'ri-virus-line', title: 'Fidye Yazılımı Koruması', desc: 'İzolasyon fidye yazılımının yayılmasını önler; ioFortify ile hızlı kurtarma.' },
  { icon: 'ri-store-line', title: 'Servis Sağlayıcılar', desc: 'Birden fazla müşteri için ayrı, yönetilebilir VDC\'ler aracılığıyla güvenli barındırma.' },
];

const faqList = [
  { q: 'Veri merkezlerinde çok kiracılılık nedir?', a: 'Veri merkezlerinde çok kiracılılık; tek bir altyapı yazılımı örneğinin ortak ayrıcalıklara sahip bir grup veya kuruluş olan birden fazla kiracıya hizmet ettiği mimariye atıfta bulunur. Bu model, gizlilik ve güvenlikten ödün vermeden ilgili altyapı maliyetlerini paylaşmak üzere organize edilmiş gruplara olanak tanır.' },
  { q: 'Çok kiracılılık VLAN\'dan nasıl farklıdır?', a: 'VLAN\'lar yalnızca ağ segmentasyonu sağlarken, VergeOS VDC\'leri işlem, depolama ve ağ dahil tüm altyapı katmanlarını kapsayan tam izolasyon sunar.' },
  { q: 'Geleneksel çok kiracılılık yaklaşımlarının zorlukları nelerdir?', a: 'Geleneksel yaklaşımlar karmaşık yapılandırma, sınırlı izolasyon, yüksek maliyet ve kiracılar arası kaynak çekişmesi sorunlarıyla karşı karşıyadır. VergeOS tüm bu engelleri ortadan kaldırır.' },
  { q: 'Sanal Veri Merkezi (VDC) nedir?', a: 'VDC, VergeOS\'ta bir veri merkezini temsil eden sanal bir kapsayıcıdır. Tüm ağ, depolama ve işlem kaynaklarını bir arada bulundurur; bağımsız olarak yönetilebilir ve klonlanabilir.' },
  { q: 'VergeOS geleneksel çok kiracılılık modellerini nasıl iyileştirir?', a: 'VergeOS, tam altyapı kapsülleme ile gerçek izolasyon sunar; diğer sistemlerde olduğu gibi yalnızca ağ katmanında değil. Bu, daha güvenli, daha ölçeklenebilir ve daha ekonomik çok kiracılılık sağlar.' },
  { q: 'VergeOS VDC\'leri felaket kurtarma için kullanılabilir mi?', a: 'Evet. VDC\'ler ağ yapılandırmaları dahil tamamen klonlanabilir. Bu, felaket kurtarma testini üretimi etkilemeden gerçekleştirmenizi ve saldırı veya arıza durumunda hızla kurtarmanızı sağlar.' },
  { q: 'VergeOS\'un VDC\'lerini fidye yazılımına karşı koruyan nedir?', a: 'İzolasyon, fidye yazılımının VDC\'ler arasında yayılmasını engeller. ioFortify entegrasyonu ile değişmez anlık görüntüler ve hızlı kurtarma da dahil kapsamlı koruma sağlanır.' },
  { q: 'VDC\'lerden kim yararlanır?', a: 'MSP\'ler, eğitim kurumları, kurumsal şirketler, araştırma kuruluşları ve küçük veri merkezleri dahil birden fazla iş yükü veya kiracı çalıştıran her kuruluş VDC teknolojisinden yararlanır.' },
];

const vdcFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'Veri merkezlerinde çok kiracılılık nedir?', acceptedAnswer: { '@type': 'Answer', text: 'Veri merkezlerinde çok kiracılılık; tek bir altyapı yazılımı örneğinin birden fazla kiracıya hizmet ettiği mimariye atıfta bulunur.' } },
    { '@type': 'Question', name: "Sanal Veri Merkezi (VDC) nedir?", acceptedAnswer: { '@type': 'Answer', text: "VDC, VergeOS'ta bir veri merkezini temsil eden sanal bir kapsayıcıdır. Tüm ağ, depolama ve işlem kaynaklarını bir arada bulundurur; bağımsız olarak yönetilebilir ve klonlanabilir." } },
    { '@type': 'Question', name: "VergeOS VDC'lerini felaket kurtarma için kullanılabilir mi?", acceptedAnswer: { '@type': 'Answer', text: "Evet. VDC'ler ağ yapılandırmaları dahil tamamen klonlanabilir. Bu, felaket kurtarma testini üretimi etkilemeden gerçekleştirmenizi sağlar." } },
    { '@type': 'Question', name: "VergeOS'un VDC'lerini fidye yazılımına karşı koruyan nedir?", acceptedAnswer: { '@type': 'Answer', text: "İzolasyon, fidye yazılımının VDC'ler arasında yayılmasını engeller. ioFortify entegrasyonu ile değişmez anlık görüntüler ve hızlı kurtarma sağlanır." } },
    { '@type': 'Question', name: "VDC'lerden kim yararlanır?", acceptedAnswer: { '@type': 'Answer', text: "MSP'ler, eğitim kurumları, kurumsal şirketler, araştırma kuruluşları ve küçük veri merkezleri dahil birden fazla iş yükü veya kiracı çalıştıran her kuruluş VDC teknolojisinden yararlanır." } },
  ],
};

const vdcAppJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeOS Sanal Veri Merkezleri',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'VergeOS ile çok kiracılı sanal veri merkezleri oluşturun. Tam izolasyon, fidye yazılımı dayanıklılığı, felaket kurtarma ve esnek kaynak sağlama ek maliyet olmadan.',
  url: `${SITE_URL}/virtual-data-centers`,
};

export default function VirtualDataCentersPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="Sanal Veri Merkezleri | Çok Kiracılı VDC | VergeOS"
        description="VergeOS ile çok kiracılı sanal veri merkezleri oluşturun. Tam izolasyon, fidye yazılımı dayanıklılığı, felaket kurtarma ve esnek kaynak sağlama ek maliyet olmadan."
        keywords="sanal veri merkezi, VDC, çok kiracılı, multi-tenant, VergeOS, veri merkezi izolasyonu, felaket kurtarma"
        canonicalPath="/virtual-data-centers"
        jsonLd={[vdcAppJsonLd, vdcFaqJsonLd]}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">Özellikler</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              VergeOS <span className="text-[#e8600a]">Sanal Veri Merkezleri</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 font-medium">Veri Merkezi Yönetimine Gelişmiş Yaklaşım</p>
          </div>
        </section>

        {/* Intro */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Ek Maliyet Olmadan Güçlü Çok Kiracılılık</h2>
                <p className="text-gray-600 mb-4 leading-relaxed">VergeOS, Sanal Veri Merkezi (VDC) teknolojisi ile <strong className="text-[#1e293b]">uygun maliyetli çok kiracılılık çözümü</strong> sunar. VDC, sanallaştırma, ağ ve depolama kaynaklarının kapsamlı bir kapsüllemesidir.</p>
                <p className="text-gray-600 mb-6 leading-relaxed">VDC'ler; MSP'lere, kuruluşlara, eğitim kurumlarına ve küçük veri merkezlerine izolasyon sağlar; iş yüklerini izole eder ve felaket kurtarmayı kolaylaştırır.</p>
                <ul className="space-y-2">
                  {['Ek maliyet olmadan çok kiracılılığın tüm faydaları', 'Tüm veri merkezi için bir sanal makinenin kapsüllenmesini taklit eder', 'MSP\'ler, kurumlar, devlet kurumları ve küçük veri merkezleri için değerli'].map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/424df76b0553b4bc505a0f57c6b7bb9d.jpg" alt="VDC Mimarisi" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-4">Temel Avantajlar ve Özellikler</h2>
            <p className="text-gray-600 text-center mb-12 text-sm max-w-2xl mx-auto">VergeOS VDC'lerinin veri merkezi yönetimini nasıl dönüştürdüğünü keşfedin</p>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {benefits.map(b => (
                <div key={b.title} className="bg-white rounded-lg border border-gray-100 p-6 text-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mx-auto mb-4"><i className={`${b.icon} text-2xl`}></i></span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{b.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Use Cases */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Temel Kullanım Senaryoları</h2>
                <p className="text-gray-600 mb-8 leading-relaxed">Çok kiracılılıkla ilgili maliyet engelleri ve karmaşıklık ortadan kalktığında VDC\'ler çok daha geniş kuruluş yelpazesine hitap eder. Küçük işletmelerden büyük şirketlere kadar hepsi VDC\'nin sunduğu gelişmiş kaynak kullanımı, basit yönetim ve operasyonel esneklikten yararlanabilir.</p>
                <div className="grid grid-cols-2 gap-4">
                  {useCases.map(u => (
                    <div key={u.title} className="flex gap-3">
                      <span className="w-8 h-8 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0"><i className={`${u.icon} text-base`}></i></span>
                      <div>
                        <p className="font-semibold text-[#1e293b] text-sm mb-1">{u.title}</p>
                        <p className="text-xs text-gray-600 leading-relaxed">{u.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=enterprise%20virtual%20data%20center%20use%20cases%20diagram%20showing%20disaster%20recovery%20patch%20testing%20ransomware%20protection%20and%20service%20provider%20hosting%20scenarios%20all%20running%20on%20isolated%20VDC%20containers%2C%20professional%20technical%20infrastructure%20visualization%20dark%20background%20orange%20highlights&width=580&height=440&seq=vdc_usecases1&orientation=landscape" alt="VDC Kullanım Senaryoları" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-white border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-4">Çok Kiracılılık ve VDC SSS</h2>
            <p className="text-gray-600 text-center mb-12 text-sm">VergeOS Sanal Veri Merkezleri Hakkında Sıkça Sorulan Sorular</p>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0"><i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i></span>
                  </button>
                  {openFaq === i && <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">{faq.a}</div>}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
